import { Card, SkeletonDisplayText, Text } from '@shopify/polaris';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import { Delta } from '../deep/Delta';
import { COLORS } from './chartTheme';

const TONE_COLORS = { critical: '#8e1f0b', success: '#0c5132' };

function Sparkline({ points, accent }) {
  const data = (points || []).map((value, index) => ({ i: index, v: Number(value) || 0 }));
  if (data.length < 2) return null;
  return (
    <div style={{ width: '100%', height: 36, marginTop: 4 }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
          <Area type="monotone" dataKey="v" stroke={accent} strokeWidth={1.5} fill={accent} fillOpacity={0.1} dot={false} activeDot={false} isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

// One headline number: label, value, an optional delta against a named period, an optional detail
// line and an optional twelve-point sparkline in the metric's accent.
export default function KpiTile({ label, value, delta, detail, spark, accent = COLORS.intake, tone, loading = false }) {
  return (
    <Card>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minHeight: 112 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: accent, flex: '0 0 auto' }} />
          <Text as="p" variant="bodySm" tone="subdued">
            {label}
          </Text>
        </div>
        {loading ? (
          <div style={{ marginTop: 6 }}>
            <SkeletonDisplayText size="medium" />
          </div>
        ) : (
          <span style={{ fontSize: 26, fontWeight: 600, lineHeight: 1.15, letterSpacing: '-0.01em', color: tone ? TONE_COLORS[tone] : 'var(--p-color-text, #303030)' }}>{value}</span>
        )}
        {!loading && delta ? (
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap', fontSize: 12 }}>
            <Delta current={delta.current} previous={delta.previous} invert={delta.invert} />
            <Text as="span" variant="bodySm" tone="subdued">
              {delta.label}
            </Text>
          </div>
        ) : null}
        {!loading && detail ? (
          <Text as="p" variant="bodySm" tone="subdued">
            {detail}
          </Text>
        ) : null}
        {!loading && spark ? <Sparkline points={spark} accent={accent} /> : null}
      </div>
    </Card>
  );
}
